export const BASE_API_URL = "https://back.medhub.zone/api";
//export const BASE_API_URL = "http://localhost:8080/api";
